import { TranslateService } from "@ngx-translate/core";
import { PopupType } from "src/app/shared/enums/popup-types";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { Picklist } from "src/app/shared/types/blog-types";
import { PicklistType } from "src/app/shared/enums/picklist-types";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PicklistService } from "src/app/shared/services/picklist.service";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-picklist-form",
  templateUrl: "./picklist-form.component.html",
  standalone: false,
})
export class PicklistFormComponent implements OnInit {
  newPickListItem: Picklist;
  public PicklistType = PicklistType;
  @Input() type!: string;
  isLoading: boolean = false;
  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private picklistService: PicklistService,
  ) {
    this.newPickListItem = {} as Picklist;
  }

  form!: FormGroup;
  @Output() notifyWhenSend: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit() {
    this.form = this.fb.group({
      name: ["", Validators.required],
    });
  }

  submitForm() {
    if (this.form.valid) {
      this.createNew();
    }
    else {
      this.form.markAllAsTouched();
    }
  }

  createNew() {
    if (!this.newPickListItem) {
      return;
    }
    this.newPickListItem.title = this.fetchData();
    this.newPickListItem.delimeter = this.getType(this.type);
    this.newPickListItem.value = "";
    this.isLoading = true;
    const subscription = this.picklistService
      .postPickListOptions(this.newPickListItem)
      .subscribe({
        next: () => {
          subscription.unsubscribe();
          this.isLoading = false;
          this.notifyWhenSend.emit(true);
          showMessage(
            PopupType.Success,
            this.translate.instant("category_added_successfully"),
          );
        },
        error: (error) => {
          subscription.unsubscribe();
          this.isLoading = false;
          this.notifyWhenSend.emit(false);
          showMessage(
            PopupType.Danger,
            error.error.errors[0]?.description || error.toString(),
          );
        },
      });
  }

  getType(type: string) {
    switch (type) {
      case "category":
        return PicklistType.Service;
      case "language":
        return PicklistType.Language;
      case "app":
        return PicklistType.Application;
      case "testemonial":
        return PicklistType.Testemonial;
      default:
        return PicklistType.Service;
    }
  }

  fetchData() {
    const { name } = this.form.getRawValue();

    return name;
  }
}
